import { render, staticRenderFns } from "./RowViewTable.vue?vue&type=template&id=4b93fd35&scoped=true&"
var script = {}
import style0 from "./RowViewTable.vue?vue&type=style&index=0&id=4b93fd35&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b93fd35",
  null
  
)

export default component.exports